module.exports = __webpack_public_path__ + "static/media/foto_1.b14c0323.png";